import { FC } from "react";

import classes from "./VoteResult.module.css";
import { VoteModelDocument } from "../votes/Vote";
import { getLang, i18n } from "../../i18n";

interface Props {
  _id: string;
  voteID: VoteModelDocument;
  deleteNotification: (id: string) => Promise<void>;
}

const VoteResult: FC<Props> = ({ _id, voteID, deleteNotification }) => {
  const lang = getLang();
  const t = i18n.voteResult[lang];
  const battle = voteID.battle;
  if (!battle) {
    return <></>;
  }
  const win = voteID.selectedArtworkID === battle.winnerArtworkID;
  console.log(voteID.selectedArtworkID);

  return (
    <div
      className={`${classes.votepair} ${classes.isResult} ${
        win ? classes.resultWin : classes.resultLose
      }`}
    >
      <div
        className={classes.delete}
        onClick={() => {
          deleteNotification(_id);
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23" fill="none">
          <path
            d="M16.2353 6.76471L6.76471 16.2353M6.76471 6.76471L16.2353 16.2353"
            stroke="#50A7EA"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      </div>

      <div className={classes.images}>
        <div
          className={`${classes.img} ${
            battle.artwork1ID === voteID.selectedArtworkID ? classes.voted : ""
          }`}
        >
          <img src={battle.artwork1Src} alt="" />
          <div
            className={`${classes.score} ${
              battle.artwork1VotesCount > battle.artwork2VotesCount
                ? classes.win
                : classes.lose
            }`}
          >
            {battle.artwork1VotesCount}
          </div>
        </div>
        <div
          className={`${classes.img} ${
            battle.artwork2ID === voteID.selectedArtworkID ? classes.voted : ""
          }`}
        >
          <img src={battle.artwork2Src} alt="" />
          <div
            className={`${classes.score} ${
              battle.artwork2VotesCount > battle.artwork1VotesCount
                ? classes.win
                : classes.lose
            }`}
          >
            {battle.artwork2VotesCount}
          </div>
        </div>
      </div>

      <div
        className={`${classes.results} ${
          win ? classes.resultWin : classes.resultLose
        }`}
      >
        <div className={classes.winrate}>
          <div className={classes.label}>{t.expertRate}</div>
          <div className={classes.value}>
            {`${((voteID.prevExpertRate || 0) * 100).toFixed(1)}`}% &rarr;{" "}
            {`${(voteID.expertRate * 100).toFixed(1)}`}%
          </div>
        </div>

        {/* Uncomment if reward is used
        <div className={classes.money}>
          <div className={classes.label}>{t.reward}</div>
          <div className={classes.value}>
            +{voteID.reward.toFixed(2)} <span className={classes.coin}>🌕</span>
          </div>
        </div>
        */}
      </div>
    </div>
  );
};

export default VoteResult;
